import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { AnalyticsState } from './state/analytics/analytics.state';
import { CartState } from './state/cart/cart.state';
import { LayoutState } from './state/layout/layout.state';
import { OrdersState } from './state/orders/orders.state';
import { KlaviyoModule } from './modules/klaviyo/klaviyo.module';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { APP_BROWSER_ROUTES } from './app-routing';
import { environment } from '@env/environment';
import { Angulartics2Module } from 'angulartics2';
import { AuthenticateModule } from '@app/modules/authenticate/authenticate.module';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SalesArticleState } from '@app/state/sales-article/sales-articles.state';
import { AccountState } from '@app/state/account/account.state';
import { BoxDealsState } from '@app/state/box-deals/box-deals.state';
import { SearchState } from '@app/state/search/search.state';
import { CartIdToHeaderInterceptorProvider } from '@app/modules/shared/interceptors/cart-id.interceptor';
import { HttpXSRFInterceptorProvider } from '@app/modules/shared/interceptors/http-xsrf.interceptor';
import { ChannelInterceptorProvider } from '@app/modules/shared/interceptors/channel.interceptor';
import { WithCredentialsInterceptorProvider } from '@app/modules/shared/interceptors/withCredentialsInterceptor';
import { AngularOpenlayersModule } from '@app/modules/points-of-interest/ngx-openlayers/angular-openlayer.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(withEventReplay()),
    provideRouter(APP_BROWSER_ROUTES),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(
      NgxsModule.forRoot(
        [
          AnalyticsState,
          CartState,
          OrdersState,
          LayoutState,
          SalesArticleState,
          AccountState,
          BoxDealsState,
          SearchState
        ],
        {
          developmentMode: !environment.production
        }
      ),
      NgxsStoragePluginModule.forRoot({ storage: 0, keys: '*' }),
      NgxsRouterPluginModule.forRoot(),
      NgxsReduxDevtoolsPluginModule.forRoot(),
      AngularOpenlayersModule
    ),
    // { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
    importProvidersFrom([
      AuthenticateModule.forRoot(),
      TranslateModule.forRoot(),
      ModalModule.forRoot(),
      KlaviyoModule.forRoot({ klaviyoToken: 'V4Lxrn' }),
      Angulartics2Module.forRoot({
        gtm: {
          userId: 'GTM-TF3M8DB'
        },
        pageTracking: {
          autoTrackVirtualPages: true
        }
      })
    ]),
    CartIdToHeaderInterceptorProvider,
    HttpXSRFInterceptorProvider,
    ChannelInterceptorProvider,
    WithCredentialsInterceptorProvider
  ]
};
